export const isNationalityBelgian = (nationality: string | undefined): boolean => {
    return nationality !== null &&
        nationality !== undefined &&
        nationality !== '' &&
        (
            nationality === 'Belg' ||
            nationality === 'Belgisch' ||
            nationality === 'Belgian' ||
            nationality === 'Belgique' ||
            nationality === 'belge'
        );
}
